import Box from "@mui/material/Box";
import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import {
	calculatefullCostingSplitQtyData,
	calculateTotalRow,
	checkForTotalColumn,
	convertSizeStringToStandardInputFormat,
	orderQtyStaticColumns,
} from "./data";
import {
	arrType,
	converAttrToDatagridCol,
	CustomDatagridEditCell,
	datatypes,
	deleteTableColumn,
	inputTypes,
	selectOptionsKeyName,
} from "data/globalData";
import { Badge, Button, ButtonGroup, Dialog, DialogActions, Divider, Stack, Tab, Tabs, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { GlobalState } from "context/GlobalContext";
import { WhiteBgBox, TotalBox } from "components/PimDashboard/DashboardComponents/Sourcing/CreateOpenCosting/data";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import { AuthState } from "context/AuthContext";
import { set } from "lodash";
import axios from "axios";
import {
	cutQtyPrefilledColumn,
	ocSplitQtyChannelSizeAssocObj,
	ocSplitQtyChannelWarehouseAssocObj,
	ocSplitQtyCutQtySplitAssocObj,
	splitQtySectionTypes,
	splitQtyTableColumns,
	totalSizeRatioColumn,
} from "../data";
import ChannelQtyWithSizeRatio from "./ChannelQtyWithSizeRatio/ChannelQtyWithSizeRatio";
import { setColumnValueBasedOnType } from "components/PimDashboard/data";
import ChannelCutQtySizeLevel from "./ChannelCutQtySizeLevel/ChannelCutQtySizeLevel";
import ChannelQtyWarehouseSplit from "./ChannelQtyWarehouseSplit/ChannelQtyWarehouseSplit";
import SizeAllChannelCutQtyRatio from "./SizeAllChannelCutQtyRatio/SizeAllChannelCutQtyRatio";
import { EditRounded } from "@mui/icons-material";
import { roundDecimalValueUptoTwo } from "utils/RoundDecimalValue";
const colStyle = {
	headerAlign: "center",
	align: "center",
	minWidth: 133,
	flex: 1,
};

const ChannelSection = ({
	rows,
	pageData,
	setPageData,
	editMode = false,
	setEditMode = () => {},
	disableEdit = false,
	handleSaveCallback = () => [],
	selectedCostingDetails,
}) => {
	const { snackBar, setLoadingOpen, setSnackBarOpen, setSnackBar } = GlobalState();
	const { user } = AuthState();

	const defTableColumns = [
		{
			...orderQtyStaticColumns.channel_total_qty,
			...colStyle,
			minWidth: 120,
			headerName: orderQtyStaticColumns.channel_total_qty.name,
			field: orderQtyStaticColumns.channel_total_qty.key,
			editable: true,
			renderCell: ({ field, row }) => {
				return <WhiteBgBox field={field} row={row} />;
			},
		},
		{
			...orderQtyStaticColumns.channel_store_grade,
			...colStyle,
			headerName: orderQtyStaticColumns.channel_store_grade.name,
			field: orderQtyStaticColumns.channel_store_grade.key,
			editable: true,

			renderCell: ({ field, row }) => {
				// if (checkForTotalColumn(row)) return <TotalBox field={field} row={row} />;
				return <WhiteBgBox field={field} row={row} />;
			},
		},
	];

	const [tableRowsState, setTableRowsState] = useState([]);
	const [allChCutQtyRows, setAllChCutQtyRows] = useState([]);
	const [channels, setChannels] = useState([]);
	const [sizes, setSizes] = useState([]);
	const [warehouses, setWarehouses] = useState([]);

	const [channelQtyTableColumns, setChannelQtyTableColumns] = useState([]);

	let [cutQtymodeModal, setCutQtyModal] = useState(false);
	let [cutQtyModeChange, setCutQtyModeChange] = useState("");

	const whSplitTableColumns = [
		{
			name: "warehouse",
			key: "warehouse",
			data_type: datatypes.STRING.key,
			input_type: inputTypes.SELECT.key,
			default_value: channels?.[0],
			[selectOptionsKeyName]: { type: arrType, list: channels.map((ch) => ({ name: ch, key: ch })) },
		},
		{
			name: "Qty Percent",
			key: "warehouse_qty_precent",
			data_type: datatypes.NUMBER.key,
			input_type: inputTypes.ENTER.key,
			default_value: channels?.[0],
			editable: true,
			renderCell: (params) => (
				<Box sx={{ display: "flex", justifyContent: "center", width: "100%", alignItems: "center" }}>
					<span>{params.value}</span>
					<Box component="span" sx={{ color: "text.secondary", fontSize: "0.875rem", ml: 1, mr: 1 }}>
						%
					</Box>
				</Box>
			),
			renderEditCell: (params) => {
				return <CustomDatagridEditCell {...params} endAndrosment="%" />;
			},
		},
	];

	useEffect(() => {
		setTableRowsState(pageData[ocSplitQtyChannelSizeAssocObj] || []);
		setAllChCutQtyRows(pageData[ocSplitQtyCutQtySplitAssocObj] || []);

		setSizes(() => {
			if (!pageData[splitQtyTableColumns.sizes.key]) return [];
			const sizes = pageData[splitQtyTableColumns.sizes.key];
			setChannelQtyTableColumns((prevCols) => {
				let newCols = [];
				sizes.forEach((size) => {
					const exists = prevCols.find((col) => col.key === size);
					if (!exists) {
						newCols.push(convertSizeStringToStandardInputFormat(size));
					} else newCols.push(exists);
				});
				return [...defTableColumns, ...newCols, totalSizeRatioColumn];
			});
			return sizes;
		});
		setChannels(() => {
			if (!pageData[splitQtyTableColumns.channels.key]) return [];
			else return pageData[splitQtyTableColumns.channels.key];
		});
		setWarehouses(() => {
			if (!pageData[splitQtyTableColumns.warehouses.key]) return [];
			return pageData[splitQtyTableColumns.warehouses.key];
		});
	}, [pageData]);

	const processRowUpdateChannelTotalQtyRow = (newRow, oldRow, channel) => {
		let correct = true;
		channelQtyTableColumns?.forEach((col) => {
			if (col.data_type === datatypes.NUMBER.key || col.data_type === datatypes.DECIMAL.key)
				if (isNaN(newRow[col.key])) correct = false;
		});

		if (correct) {
			let sysFields = {
				is_updated: true,
				last_updated_by: user.email,
			};
			let totalSizeRatio = 0;
			setTableRowsState((prev) => {
				const rows = prev.map((row) => {
					if (row.channel === channel) {
						const {
							id,
							channel_total_qty,
							channel_store_grade,
							[totalSizeRatioColumn.key]: totalSizeRatioValue, // to remove column form rest variable
							...rest //sizes
						} = newRow;
						let obj = { ...row };
						Object.values(orderQtyStaticColumns).forEach((col) => {
							if (row[col.key] !== setColumnValueBasedOnType(col, newRow[col.key])) {
								obj[col.key] = setColumnValueBasedOnType(col, newRow[col.key]);
								obj = { ...obj, ...sysFields };
							}
						});
						Object.keys(rest).forEach((sizeKey) => {
							if (row.size === sizeKey && row["size_qty_precent"] !== rest[sizeKey]) {
								obj["size_qty_precent"] = +rest[sizeKey];
								totalSizeRatio += +rest[sizeKey];
								obj = { ...obj, ...sysFields };
							} else totalSizeRatio += +row["size_qty_precent"];
						});
						console.log("s", obj);
						return obj;
					} else return row;
				});
				const calFullData = calculatefullCostingSplitQtyData({
					...pageData,
					[ocSplitQtyChannelSizeAssocObj]: rows,
					[ocSplitQtyCutQtySplitAssocObj]: [...allChCutQtyRows],
				});
				// console.log(calFullData, "sdfghjkjhgfd");
				return calFullData[ocSplitQtyChannelSizeAssocObj];
			});

			return { ...newRow, [totalSizeRatioColumn.key]: totalSizeRatio };
		} else {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Please Enter Proper Values",
				severity: "warning",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};
	const processRowUpdateChSizeCutQtyRow = (newRow, oldRow) => {
		const cut_qty = +newRow.cut_qty;
		if (Number.isFinite(cut_qty)) {
			let sysFields = {
				is_updated: true,
				last_updated_by: user.email,
			};
			setTableRowsState((prev) => {
				const rows = prev.map((row) => {
					if (row.channel === newRow.channel && row.size === newRow.size) {
						return { ...row, cut_qty, ...sysFields };
					} else return row;
				});
				const calFullData = calculatefullCostingSplitQtyData({
					...pageData,
					[ocSplitQtyChannelSizeAssocObj]: rows,
					[ocSplitQtyCutQtySplitAssocObj]: [...allChCutQtyRows],
				});
				// console.log(calFullData, "sdfghjkjhgfd");
				return calFullData[ocSplitQtyChannelSizeAssocObj];
			});

			return { ...newRow, cut_qty };
		} else {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Please Enter Proper Values",
				severity: "warning",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};
	const processRowUpdateAllChCutQtyRow = (newRow, oldRow) => {
		console.log(newRow, "fvghjhgfcvhvfghbvfghn");
		const cut_qty = +newRow.cut_qty;

		if (Number.isFinite(cut_qty)) {
			let sysFields = {
				is_updated: true,
				last_updated_by: user.email,
			};
			let cut_qty_percent = roundDecimalValueUptoTwo((cut_qty / newRow.order_qty) * 100);
			cut_qty_percent = Number.isFinite(cut_qty_percent) ? cut_qty_percent : 0;
			setAllChCutQtyRows((prev) => {
				const rows = prev.map((row) => {
					if (row.size === newRow.size) {
						return { ...row, cut_qty, cut_qty_percent, ...sysFields };
					} else return row;
				});

				const calFullData = calculatefullCostingSplitQtyData({
					...pageData,
					[ocSplitQtyCutQtySplitAssocObj]: rows,
					[ocSplitQtyChannelSizeAssocObj]: [...tableRowsState],
				});
				console.log(calFullData, "sdfghjkjhgfd");
				setTableRowsState(calFullData[ocSplitQtyChannelSizeAssocObj]);
				return calFullData[ocSplitQtyCutQtySplitAssocObj];
			});

			return { ...newRow, cut_qty, cut_qty_percent };
		} else {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Please Enter Proper Values",
				severity: "warning",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};
	const processRowUpdateWhRatioChange = (newRow, oldRow) => {
		console.log(newRow, "fvghjhgfcvhvfghbvfghn");
		const warehouse_qty_precent = +newRow.warehouse_qty_precent;

		if (Number.isFinite(warehouse_qty_precent)) {
			let sysFields = {
				is_updated: true,
				last_updated_by: user.email,
			};

			let chSizes = tableRowsState.map((chSize) => {
				if (chSize.channel === newRow.channel) {
					// CHANNEL SIZE WH ASSOC
					console.log("in ch size levelellldfmn,bcvmxfc");
					let qtyWhList = chSize[ocSplitQtyChannelWarehouseAssocObj];
					qtyWhList = qtyWhList.map((whQty) => {
						if (whQty.warehouse === newRow.warehouse) {
							return { ...whQty, warehouse_qty_precent, ...sysFields };
						} else return whQty;
					});
					console.log("in ch size warehouse", warehouse_qty_precent, qtyWhList);

					return { ...chSize, [ocSplitQtyChannelWarehouseAssocObj]: [...qtyWhList] };
				} else return chSize;
			});
			const calFullData = calculatefullCostingSplitQtyData({
				...pageData,
				[ocSplitQtyCutQtySplitAssocObj]: [...allChCutQtyRows],
				[ocSplitQtyChannelSizeAssocObj]: [...chSizes],
			});
			console.log(calFullData[ocSplitQtyChannelSizeAssocObj], "sdjgfdsfghjhgfdsfghjgfghfdghgfghj");

			setTableRowsState(calFullData[ocSplitQtyChannelSizeAssocObj]);
			return { ...newRow, warehouse_qty_precent, ...sysFields };
		} else {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Please Enter Proper Values",
				severity: "warning",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};

	const handleBulkPasteChannelSizeRatio = (pastedData, channel) => {
		const sysFields = { is_updated: true, last_updated_by: user.email };
		setTableRowsState((prev) => {
			const rows = prev.map((row) => {
				if (row.channel !== channel) return row;
				const match = pastedData.sizeRows.find((p) => p.size === row.size);
				let updated = { ...row };
				if (match) updated = { ...updated, size_qty_precent: +match.size_qty_precent };
				if (pastedData.channel_total_qty !== undefined)
					updated = { ...updated, channel_total_qty: +pastedData.channel_total_qty };
				if (pastedData.channel_store_grade !== undefined)
					updated = { ...updated, channel_store_grade: pastedData.channel_store_grade };
				return { ...updated, ...sysFields };
			});
			const calFullData = calculatefullCostingSplitQtyData({
				...pageData,
				[ocSplitQtyChannelSizeAssocObj]: rows,
				[ocSplitQtyCutQtySplitAssocObj]: [...allChCutQtyRows],
			});
			return calFullData[ocSplitQtyChannelSizeAssocObj];
		});
	};

	const handleBulkPasteChCutQty = (pastedRows, channel) => {
		const sysFields = { is_updated: true, last_updated_by: user.email };
		setTableRowsState((prev) => {
			const rows = prev.map((row) => {
				if (row.channel !== channel) return row;
				const match = pastedRows.find((p) => p.size === row.size);
				if (!match) return row;
				return { ...row, cut_qty: +match.cut_qty, ...sysFields };
			});
			const calFullData = calculatefullCostingSplitQtyData({
				...pageData,
				[ocSplitQtyChannelSizeAssocObj]: rows,
				[ocSplitQtyCutQtySplitAssocObj]: [...allChCutQtyRows],
			});
			return calFullData[ocSplitQtyChannelSizeAssocObj];
		});
	};

	const handleBulkPasteAllChCutQty = (pastedRows) => {
		const sysFields = { is_updated: true, last_updated_by: user.email };
		setAllChCutQtyRows((prev) => {
			const rows = prev.map((row) => {
				const match = pastedRows.find((p) => p.size === row.size);
				if (!match) return row;
				const cut_qty = +match.cut_qty;
				let cut_qty_percent = roundDecimalValueUptoTwo((cut_qty / row.order_qty) * 100);
				cut_qty_percent = Number.isFinite(cut_qty_percent) ? cut_qty_percent : 0;
				return { ...row, cut_qty, cut_qty_percent, ...sysFields };
			});
			const calFullData = calculatefullCostingSplitQtyData({
				...pageData,
				[ocSplitQtyCutQtySplitAssocObj]: rows,
				[ocSplitQtyChannelSizeAssocObj]: [...tableRowsState],
			});
			setTableRowsState(calFullData[ocSplitQtyChannelSizeAssocObj]);
			return calFullData[ocSplitQtyCutQtySplitAssocObj];
		});
	};

	const handleBulkPasteWhRatio = (pastedRows, channel) => {
		const sysFields = { is_updated: true, last_updated_by: user.email };
		const chSizes = tableRowsState.map((chSize) => {
			if (chSize.channel !== channel) return chSize;
			const qtyWhList = chSize[ocSplitQtyChannelWarehouseAssocObj].map((whQty) => {
				const match = pastedRows.find((p) => p.warehouse === whQty.warehouse);
				if (!match) return whQty;
				return { ...whQty, warehouse_qty_precent: +match.warehouse_qty_precent, ...sysFields };
			});
			return { ...chSize, [ocSplitQtyChannelWarehouseAssocObj]: qtyWhList };
		});
		const calFullData = calculatefullCostingSplitQtyData({
			...pageData,
			[ocSplitQtyCutQtySplitAssocObj]: [...allChCutQtyRows],
			[ocSplitQtyChannelSizeAssocObj]: [...chSizes],
		});
		setTableRowsState(calFullData[ocSplitQtyChannelSizeAssocObj]);
	};

	// cut qty mode confirm modal
	const handleCutQtyModeChangeClick = (mode = "automated" || "manual") => {
		if (pageData?.[cutQtyPrefilledColumn.key] === true && mode === "automated") return;
		if (pageData?.[cutQtyPrefilledColumn.key] === false && mode === "manual") return;

		setCutQtyModal(true);
		setCutQtyModeChange(mode);
	};
	const handleCutQtyModeChangeCancelClick = () => {
		setCutQtyModal(false);
		setCutQtyModeChange("");
	};
	const handleCutQtyModeChangeFinalSubmit = async (e) => {
		e.preventDefault();

		try {
			setLoadingOpen(true);
			const res = await axios.patch(`/api/sourcing/update_split_qty_cut_qty_mode/${selectedCostingDetails?.style_ref_no}`, {
				[cutQtyPrefilledColumn.key]: cutQtyModeChange === "automated" ? true : false,
			});
			if (res) {
				setPageData((prev) => {
					return { ...prev, [cutQtyPrefilledColumn.key]: cutQtyModeChange === "automated" ? true : false };
				});
				setCutQtyModal(false);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: `Mode Changed Successfully`,
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setCutQtyModeChange("");
				setLoadingOpen(false);
			}
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrorMessage(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};

	const handleSaveCancelClick = () => {
		setEditMode("");
		setTableRowsState([...pageData[ocSplitQtyChannelSizeAssocObj]] || []);
		setAllChCutQtyRows([...pageData[ocSplitQtyCutQtySplitAssocObj]] || []);
	};
	const handleSaveClick = async () => {
		try {
			setLoadingOpen(true);
			const res = await axios.put(`/api/sourcing/update_split_qty_assoc_data/${pageData?.id}`, {
				...pageData,
				[ocSplitQtyChannelSizeAssocObj]: tableRowsState,
				[ocSplitQtyCutQtySplitAssocObj]: allChCutQtyRows,
			});
			if (res) {
				handleSaveCallback(res.data.result);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Data Saved Successfully",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				setLoadingOpen(false);
			}
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: parseErrorMessage(error),
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
		}
	};

	return (
		<Stack spacing={2} width="100%" sx={{ overflowY: "auto" }}>
			<Box width="100%" display="flex" justifyContent="space-between" alignItems="center" mb={2}>
				<Typography variant="h6">Qty Breakdown</Typography>

				<Box display="flex" columnGap="10px" alignItems="center">
					<Typography>Size Cut Qty Mode</Typography>
					<ButtonGroup>
						<Button
							disabled={disableEdit || editMode}
							variant={pageData?.[cutQtyPrefilledColumn.key] ? "outlined" : "contained"}
							onClick={() => handleCutQtyModeChangeClick("manual")}>
							Manual
						</Button>
						<Button
							disabled={disableEdit || editMode}
							variant={pageData?.[cutQtyPrefilledColumn.key] ? "contained" : "outlined"}
							onClick={() => handleCutQtyModeChangeClick("automated")}>
							Automated
						</Button>
					</ButtonGroup>
				</Box>
				{editMode && !disableEdit ? (
					<Box display="flex" columnGap="10px">
						<Button variant="outlined" size="small" onClick={handleSaveCancelClick}>
							Cancel Edit
						</Button>
						<Button variant="contained" size="small" onClick={handleSaveClick}>
							Save
						</Button>
					</Box>
				) : (
					<Button
						disabled={disableEdit}
						variant="contained"
						size="small"
						onClick={() => setEditMode(splitQtySectionTypes.order_qty_input.key)}
						startIcon={<EditRounded />}>
						Edit
					</Button>
				)}
			</Box>
			<Box display="flex" width="100%" columnGap="20px" sx={{ overflowX: "auto", pb: 1 }}>
				{channels.map((channel, idx) => (
					<Stack
						flexShrink={0}
						spacing={2}
						sx={{
							width: "35%",
							maxWidth: "500px",
							border: `1px solid ${grey[200]}`,
							borderRadius: 2,
							overflow: "hidden",
							boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
							background: "#fff",
						}}>
						<Box sx={{ background: grey[900], px: 2, py: 1 }}>
							<Typography variant="subtitle1" fontWeight={700} color="#fff" letterSpacing={1}>
								{channel}
							</Typography>
						</Box>
						<Stack spacing={2} p={2}>
							<ChannelQtyWithSizeRatio
								tableColumns={channelQtyTableColumns}
								channel={channel}
								channelQtyData={tableRowsState || []}
								handleDataChange={processRowUpdateChannelTotalQtyRow}
								allChannels={channels}
								allSizes={sizes}
								editMode={editMode}
								handleBulkPaste={handleBulkPasteChannelSizeRatio}
							/>
							<Divider sx={{ width: "100%" }} />
							<Box>
								<SizeAllChannelCutQtyRatio
									hideContent={idx !== 0}
									tableRows={allChCutQtyRows || []}
									channelSizeRows={tableRowsState || []}
									handleDataChange={processRowUpdateAllChCutQtyRow}
									allChannels={channels}
									allSizes={sizes}
									editMode={editMode}
									manualMode={!pageData?.[cutQtyPrefilledColumn.key]}
									handleBulkPaste={handleBulkPasteAllChCutQty}
								/>
								<ChannelCutQtySizeLevel
									tableColumns={channelQtyTableColumns}
									channel={channel}
									channelQtyData={tableRowsState || []}
									handleDataChange={processRowUpdateChSizeCutQtyRow}
									allChannels={channels}
									allSizes={sizes}
									editMode={!disableEdit && editMode && !pageData[cutQtyPrefilledColumn.key]}
									handleBulkPaste={handleBulkPasteChCutQty}
								/>
							</Box>

							<Divider sx={{ width: "100%" }} />

							<ChannelQtyWarehouseSplit
								tableColumns={whSplitTableColumns}
								channel={channel}
								channelQtyData={pageData?.[ocSplitQtyChannelSizeAssocObj] || []}
								whSplitRows={
									tableRowsState?.reduce((acc, row) => {
										if (
											row[ocSplitQtyChannelWarehouseAssocObj] &&
											Array.isArray(row[ocSplitQtyChannelWarehouseAssocObj])
										)
											acc = [
												...acc,
												...row[ocSplitQtyChannelWarehouseAssocObj].map((r) => ({
													...r,
													channel: row.channel,
													size: row.size,
												})),
											];
										return acc;
									}, []) || []
								}
								handleDataChange={processRowUpdateWhRatioChange}
								allChannels={channels}
								allSizes={sizes}
								allWarehouses={warehouses}
								editMode={editMode}
								handleBulkPaste={handleBulkPasteWhRatio}
							/>
						</Stack>
					</Stack>
				))}
			</Box>
			<Dialog
				fullWidth
				maxWidth="md"
				open={cutQtymodeModal}
				onClose={handleCutQtyModeChangeCancelClick}
				component="form"
				onSubmit={handleCutQtyModeChangeFinalSubmit}>
				<Box width="98%" p={2} boxSizing="border-box">
					<Stack direction="row" width="100%" flexWrap="wrap" columnGap="1%" rowGap={1}>
						<Typography variant="h6" width="100%" pl={1}>
							Do you really want to change cut qty mode to {cutQtyModeChange.toUpperCase()}?
						</Typography>
						<Typography variant="body1" width="100%" pl={1} color="red">
							*Data will be affected
						</Typography>
					</Stack>
				</Box>
				<DialogActions>
					<Button variant="outlined" onClick={handleCutQtyModeChangeCancelClick}>
						Cancel
					</Button>
					<Button autoFocus variant="contained" sx={{ mr: 1 }} type="submit">
						Save
					</Button>
				</DialogActions>
			</Dialog>
		</Stack>
	);
};

export default ChannelSection;
